module.exports = __webpack_public_path__ + "img/Bouclier09.59ef1246.png";